import tdLocalStorage from './tdLocalStorage.js';


export default class tdMultiUserLogin {

    static addMultiUserLogin(loginObj) {
        let multiUserLoginSearch = tdMultiUserLogin.getMultiUserLogin(loginObj);

        if (multiUserLoginSearch === null) {
            let allMultiUserLogin = tdMultiUserLogin.getAllMultiUserLogin();
            if (allMultiUserLogin === null) {
                allMultiUserLogin = [loginObj];
            } else {
                allMultiUserLogin.push(loginObj);
            }

            tdLocalStorage.set('multiUserLoginStoreNew', allMultiUserLogin);
        }

        // the user already exists
    }

    static deleteMultiUserLogin(index) {
        let multiUserLoginStore = tdLocalStorage.get('multiUserLoginStoreNew');

        if (multiUserLoginStore[index] === undefined) {
            return false;
        }

        multiUserLoginStore.splice(index, 1);
        tdLocalStorage.set('multiUserLoginStoreNew', multiUserLoginStore);
        return true;
    }

    /**
     *
     * @returns {null|*}
     */
    static getAllMultiUserLogin() {
        let multiUserLoginStore = tdLocalStorage.get('multiUserLoginStoreNew');
        return multiUserLoginStore;
    }

    /**
     *
     * @param loginObj
     * @returns {null|*}
     */
    static getMultiUserLogin(loginObj) {
        let session_token = loginObj.session_token,
            session_company_id = loginObj.session_company_id,
            multiUserLoginStore = tdLocalStorage.get('multiUserLoginStoreNew');

        if (multiUserLoginStore === null) {
            return null;
        }

        for (let i = 0; i < multiUserLoginStore.length; i++) {
            if (multiUserLoginStore[i].session_token === session_token && multiUserLoginStore[i].session_company_id === session_company_id) {
                return multiUserLoginStore[i];
            }
        }

        return null;
    }

}



// WEBPACK FOOTER //
// ./src/tdMultiUserLogin.js